module.exports = __webpack_public_path__ + "img/check.c3613abe.svg";